export enum Keys {
    Backspace = 8,
    Control = 17,
    Delete = 46,
    Down = 40,
    End = 35,
    Enter = 13,
    Esc = 27,
    Home = 36,
    Insert = 45,
    Left = 37,
    Right = 39,
    Shift = 16,
    Space = 32,
    Tab = 9,
    Up = 38,
    Alt = 18,
    A = 65,
    C = 67
}
